// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ApiFilledSvg from "@fishx/icons-svg/es/asn/ApiFilled";
import FishxIcon from '../components/FishxIcon';

var ApiFilled = function ApiFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ApiFilledSvg
  }));
};

ApiFilled.displayName = 'ApiFilled';
export default React.forwardRef(ApiFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ApiFilled.js
// module id = 1998
// module chunks = 0